import { hasValue } from "../Helpers/validations/common";

export const ReportTypes = [
  Object.freeze({
    id: "0",
    name: "ReportBookNotReceived",
    description: "ReportBookNotReceivedDescription",
    statsName: "percentReportedByNeverRecivedBooks",
  }),
  Object.freeze({
    id: "1",
    name: "ReportGaveBookToTeacher",
    description: "ReportGaveBookToTeacherDescription",
    statsName: "percentReportedByGaveToTeacherBooks",
  }),
  Object.freeze({
    id: "2",
    name: "ReportAlreadyReturned",
    description: "ReportAlreadyReturnedDescription",
    statsName: "percentReportedByAlreadyTurnedBooks",
  }),
  Object.freeze({
    id: "3",
    name: "ReportLostBook",
    description: "ReportLostBookDescription",
    statsName: "percentReportedByLostBooks",
  }),
];

export const ReportTypesFilter = [
  Object.freeze({
    id: "",
    name: "All",
    description: "All",
    statsName: "All",
  }),
  ...ReportTypes,
];

export const getReportTypeIdByName = (reportTypeName) => {
  if (hasValue(reportTypeName)) {
    return (
      ReportTypes.find((reportType) => reportType.name === reportTypeName)
        ?.id || ""
    );
  }
};

export const getReportTypeName = (reportTypeValue) => {
  if (hasValue(reportTypeValue)) {
    return (
      ReportTypes.find(
        (reportType) => reportType.id === reportTypeValue.toString()
      )?.name || ""
    );
  }
};

export const getReportTypeDescription = (reportTypeValue) => {
  if (hasValue(reportTypeValue)) {
    return (
      ReportTypes.find(
        (reportType) => reportType.id === reportTypeValue.toString()
      )?.description || ""
    );
  }
};

export const getReportTypeByCustomKeyValue = (key, value) => {
  return ReportTypes.find((reportType) => reportType[key] === value) || "";
};

export const getReportTypeById = (id) => {
  return ReportTypes.find((reportType) => reportType.id === id) || "";
};
